import { apiClient, handleResponse } from './axios';

async function getCompanyById(companyId) {
  try {
    const response = await apiClient.get(`/company/${companyId}`);
    const user = await handleResponse(response);
    return user;
  } catch (error) {
    return error.response;
  }
}

async function newCompany(company) {
  const url = '/company/';
  try {
    const response = await apiClient.post(url, company);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function newCompanyWithCustomer(company) {
  const url = '/company/customer';
  try {
    const response = await apiClient.post(url, company);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getAllCompany() {
  const url = '/company/';
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getAllCompanyData() {
  const url = '/companydata/';
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getCompanyExports(groupId) {
  try {
    const response = await apiClient.get(`/company/export/${groupId}`);
    const user = await handleResponse(response);
    return user;
  } catch (error) {
    return error.response;
  }
}

async function getCompanyFDRExports() {
  const url = '/company/fdr';
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getCompanyWithGroups(companyId) {
  try {
    const response = await apiClient.get(`/company/allGroups/${companyId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getCompaniesWithGroups() {
  try {
    const response = await apiClient.get('/company/groups/');
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function updateExamConcerned(companyId) {
  try {
    const response = await apiClient.put(`/companyData/examConcerned/${companyId}`);
    const user = await handleResponse(response);
    return user;
  } catch (error) {
    return error.response;
  }
}

async function updateCompanySemesters(companyId, body) {
  try {
    const response = await apiClient.put(`/companyData/semesters/${companyId}`, body);
    const user = await handleResponse(response);
    return user;
  } catch (error) {
    return error.response;
  }
}

async function updateCompanyCriterias(companyId, body) {
  try {
    const response = await apiClient.put(`/companyData/criterias/${companyId}`, body);
    const user = await handleResponse(response);
    return user;
  } catch (error) {
    return error.response;
  }
}

async function getArchivedCompanies() {
  const url = '/company/archived';
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getCompanyBygroupId(id) {
  const url = `/company/group/${id}`;
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function nextSemester(id) {
  const url = `/company/nextsemester/${id}`;
  try {
    const response = await apiClient.put(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function setSubGroups(id) {
  const url = `/company/setSubGroups/${id}`;
  try {
    const response = await apiClient.put(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function nextSemesterGroup(direction, companyId, semester) {
  const url = `/company/next/semester/group/${direction}/${companyId}/${semester}`;
  try {
    const response = await apiClient.put(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getExports() {
  const url = '/company/export';
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function searchCompanies(search) {
  try {
    const response = await apiClient.get(`/company/search/${search}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function searchCompaniesWithGroups(search) {
  try {
    const response = await apiClient.get(`/company/groups/search/${search}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function blockCompany(companyId, data) {
  const url = `/company/block/${companyId}`;
  try {
    const response = await apiClient.put(url, data);
    const company = await handleResponse(response);
    return company;
  } catch (error) {
    return error.response;
  }
}

async function updateCompany(companyId, data) {
  const url = `/company/${companyId}`;
  try {
    const response = await apiClient.put(url, data);
    const company = await handleResponse(response);
    return company;
  } catch (error) {
    return error.response;
  }
}

async function deleteCompany(companyId) {
  const url = `/company/${companyId}`;
  try {
    const response = await apiClient.delete(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function unarchiveCompany(companyId) {
  const url = `/company/archive/${companyId}`;
  try {
    const response = await apiClient.put(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getCountry() {
  const url = '/country/';
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getCompanyDataById(companyId) {
  try {
    const response = await apiClient.get(`/companyData/${companyId}`);
    const user = await handleResponse(response);
    return user;
  } catch (error) {
    return error.response;
  }
}

async function updateCompanyAdminData(companyId, body) {
  try {
    const response = await apiClient.put(`/companyData/admin/${companyId}`, body);
    const user = await handleResponse(response);
    return user;
  } catch (error) {
    return error.response;
  }
}

async function updateCompanyPedagogicData(companyId, body) {
  try {
    const response = await apiClient.put(`/companyData/pedagogic/${companyId}`, body);
    const user = await handleResponse(response);
    return user;
  } catch (error) {
    return error.response;
  }
}

async function updateCompanyDataPonderation(companyId, ponderation) {
  const url = `/companyData/${companyId}/${ponderation}`;
  try {
    const response = await apiClient.put(url);
    const company = await handleResponse(response);
    return company;
  } catch (error) {
    return error.response;
  }
}

async function copyGroupsFromCompany(companyCreatedId, companyCopiedId) {
  const body = {
    companyCreatedId,
    companyCopiedId,
  };
  try {
    const response = await apiClient.post('/company/copyGroups', body);
    const company = await handleResponse(response);
    return company;
  } catch (error) {
    return error.response;
  }
}

async function getEWCompanies() {
  try {
    const response = await apiClient.get('/company/EW');
    const companies = await handleResponse(response);
    return companies;
  } catch (error) {
    return error.response;
  }
}

async function addPresentialGroups(companyId, body) {
  try {
    const response = await apiClient.post(`/company/presential-groups/${companyId}`, { presentialGroups: body });
    const company = await handleResponse(response);
    return company;
  } catch (error) {
    return error.response;
  }
}

async function updatePresentialGroup(groupId, body) {
  try {
    const response = await apiClient.post(`/company/presential-groups/update/${groupId}`, { presentialGroup: body });
    const company = await handleResponse(response);
    return company;
  } catch (error) {
    return error.response;
  }
}

const companyServices = {
  addPresentialGroups,
  updatePresentialGroup,
  copyGroupsFromCompany,
  getCompanyById,
  getCompanyWithGroups,
  newCompany,
  setSubGroups,
  updateCompanyAdminData,
  updateCompanyPedagogicData,
  getCompanyDataById,
  getArchivedCompanies,
  unarchiveCompany,
  getCompanyExports,
  getCompaniesWithGroups,
  updateCompanyCriterias,
  deleteCompany,
  blockCompany,
  getCompanyFDRExports,
  updateExamConcerned,
  updateCompany,
  nextSemester,
  nextSemesterGroup,
  getAllCompanyData,
  getAllCompany,
  getExports,
  updateCompanySemesters,
  searchCompanies,
  searchCompaniesWithGroups,
  getCountry,
  getCompanyBygroupId,
  newCompanyWithCustomer,
  updateCompanyDataPonderation,
  getEWCompanies,
};

export default companyServices;
